import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'transformBooleanToYesOrNo',
  standalone: true,
})
export class TransformBooleanToYesOrNoPipe implements PipeTransform {
  readonly #translateService = inject(TranslateService);

  transform(value?: boolean | null): string {
    if (typeof value === 'undefined' || value === null) {
      return '';
    }
    return value ? this.#translateService.instant('WORD.YES') : this.#translateService.instant('WORD.NO');
  }
}
